import { ADDITIONAL_DETAILS_INITIAL_LOAD } from './action';

const additionalFieldsInitialValuesReducer = (state = {}, action) => {
    switch (action.type) {
        case ADDITIONAL_DETAILS_INITIAL_LOAD:
            return {
                ...state,
                intialAdditionalFields: action.data
            }

        default:
            return state
    }
}

export default additionalFieldsInitialValuesReducer;